import * as v from "valibot";
import { RewardKind } from "../__generated__/RewardFragment.graphql";
import { LocationKind } from "@/pages/__generated__/ActivityScaffoldQuery.graphql";
import { EVENT_ORDER } from "@/utils/eventOrder";

export const REWARDS = Object.freeze([
  "BADGE",
  "LEARNING",
  "MONEY",
  "SWAG",
]) satisfies ReadonlyArray<RewardKind>;

export const LOCATIONS = Object.freeze([
  "HYBRID",
  "IN_PERSON",
  "ONLINE",
]) satisfies ReadonlyArray<LocationKind>;

export const schema = v.object({
  search: v.nullish(v.string(), null),
  tags: v.nullish(v.array(v.string()), undefined),
  rewards: v.nullish(v.array(v.picklist(REWARDS)), undefined),
  location: v.nullish(v.picklist(LOCATIONS), undefined),
  sort: v.nullish(v.picklist(EVENT_ORDER.keys), "priority"),
});

export type Schema = typeof schema;
export type SchemaInput = v.InferInput<Schema>;
export type SchemaOutput = v.InferOutput<Schema>;

export const DEFAULT_EVENT_QUERY_FILTERS = v.getDefaults(schema);
